import { defineSlotRecipe } from '@chakra-ui/react';

export const expandableMenuItemSlotRecipe = defineSlotRecipe({
    slots: ['trigger', 'label', 'item', 'dropdown'],
    base: {
        label: {
            color: 'secondary.solid',
        },
        dropdown: {
            position: 'absolute',
            top: 0,
            left: '100%',
            height: '100%',
            width: 'max-content',
            overflowX: 'auto',
            bgColor: 'secondary.50',
        },
    },
});
